
import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  
  TableBody,
  
} from "@material-ui/core";

import { makeStyles } from "@material-ui/styles";
import moment from "moment/moment";
import EmptyData from "../../../../StyledComponents/Table/EmptyData";
import TableSkeleton from "../../../../StyledComponents/TableSkeleton";

import jwt from "jsonwebtoken";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },
  },
});
function Signatories_Table({
  vendorList,
  loading,
  errorMessage,
}) {
  const token = localStorage.getItem("user_token");
  const user = jwt.decode(token);
  const classes = useStyles();
  const [detail, setDetail] = useState([]);
  const [chequeDetail, setChequeDetail] = useState([]);
  const [data,setData]=useState(vendorList)
  useEffect(()=>{
    const signatoryData=vendorList?.filter((item) => item?.batchEmail.includes(user.Email))
    if(signatoryData.length>0){
      setData(signatoryData)
    }
  },[vendorList])

  const toggleDetail = (position) => {
    setDetail((prev) =>
      prev.includes(position) ? prev.filter((i) => i !== position) : [...prev, position]
    );
  };

  const toggleChequeDetail = (chequeNo) => {
    setChequeDetail((prev) =>
      prev.includes(chequeNo) ? prev.filter((i) => i !== chequeNo) : [...prev, chequeNo]
    );
  };


  return (
    <div>
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12} mt={2}>
          {errorMessage && <span style={{ color: "red", marginBottom: "5px" }}>{errorMessage}</span>}
          <TableContainer className="scrollable">
            <Table className={classes.table} aria-label="a dense table" size="small">
              <TableHead>
                <TableRow sx={{ backgroundColor: "#EFF2F4" }}>
               
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}    align="center">Batch No</TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}    align="center">Batch Date</TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}    align="center">No of Cheque</TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}    align="center">Batch Amount</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.map((item) => (
                  <>
                    <TableRow>
                     
                      <TableCell onClick={() => toggleDetail(item.batchNo)}  sx={{
                            width: "10%",
                            cursor: "pointer",
                            textAlign: "center",
                          }}>{item?.batchNo}</TableCell>
                      <TableCell  sx={{
                            width: "10%",
                            cursor: "pointer",
                            textAlign: "center",
                          }}>{moment(item?.batchDate).format("YYYY-MM-DD")}</TableCell>
                      <TableCell  sx={{
                            width: "10%",
                            cursor: "pointer",
                            textAlign: "center",
                          }}>{item?.noOfCheque}</TableCell>
                      <TableCell   sx={{
                            width: "10%",
                            cursor: "pointer",
                            textAlign: "center",
                          }}>{Number(item?.batchAmount).toLocaleString()}</TableCell>
                    </TableRow>
                    {detail.includes(item.batchNo) && (
                      <>
                        <TableRow>
                        <TableCell colSpan={6}>
                            <Table
                              style={{ margin: "20px 0px" }}
                              aria-label="a dense table"
                              size="small"
                            >
                              <TableHead>
                                <TableRow sx={{ backgroundColor: "#EFF2F4" }}>
                                <TableCell
                                    sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}
                                  >
                                    S#
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}
                                  >
                                    Cheque
                                  </TableCell>                     
                                  <TableCell
                                    sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}
                                  >
                                    Document No
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}
                                  >
                                    Payment Date
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}
                                  >

                                    Vendor Code
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}
                                  >
                                    Vendor Name
                                  </TableCell>            
                                  <TableCell
                                    sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}
                                  >
                                    Net Amount Paid
                                  </TableCell>
                                  </TableRow>
                                
                                  </TableHead>
                                  {item.batchPayment?.map((payment,index) => (
                          <>
                            <TableRow>
                            <TableCell style={{ color: "black", width: "10%" }}onClick={() => toggleChequeDetail(payment.chequeDetail.chequeNo)}>
                                {index+1}
                              </TableCell>
                              <TableCell style={{ color: "black", width: "10%" }}onClick={() => toggleChequeDetail(payment.chequeDetail.chequeNo)}>
                                {payment.chequeDetail.chequeNo}
                              </TableCell>
                              <TableCell style={{ color: "black", width: "10%" }}onClick={() => toggleChequeDetail(payment.chequeDetail.chequeNo)}>
                                {payment.chequeDetail.documentNumber}
                              </TableCell>
                              <TableCell style={{ color: "black", width: "10%" }}onClick={() => toggleChequeDetail(payment.chequeDetail.chequeNo)}>
                                {payment.chequeDetail.paymentDate}
                              </TableCell>
                              <TableCell style={{ color: "black", width: "10%" }} onClick={() => toggleChequeDetail(payment.chequeDetail.chequeNo)}>
                                {payment.chequeDetail.vendor_Code}
                              </TableCell>
                              <TableCell style={{ color: "black", width: "10%" }} onClick={() => toggleChequeDetail(payment.chequeDetail.chequeNo)}>
                                {payment.chequeDetail.vendor_Name}
                              </TableCell>
                              <TableCell style={{ color: "black", width: "10%" }} onClick={() => toggleChequeDetail(payment.chequeDetail.chequeNo)}>
                                {Number(payment.chequeDetail.chequeAmount).toLocaleString()}
                              </TableCell>
                            </TableRow>
                            {chequeDetail.includes(payment.chequeDetail.chequeNo) && (
                            <TableRow>
                            <TableCell colSpan={7}>
                                <Table
                                  style={{ margin: "20px 0px" }}
                                  aria-label="a dense table"
                                  size="small"
                                >
                               <TableHead>
                               <TableRow sx={{ backgroundColor: "#EFF2F4" }}>
                               <TableCell  sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}>S#</TableCell>
                                  <TableCell  sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}
                                   
                                    >Invoice No</TableCell>
                                  <TableCell  sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}>Invoice Date</TableCell>
                                  <TableCell sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}>Invoice Amount</TableCell>
                                  <TableCell  sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}>Invoice Description</TableCell>
                                     <TableCell  sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}>Barcode No</TableCell>
                                </TableRow>
                                </TableHead>
                                {payment.chequeDetail.invoices?.map((inv, index) => (
                                  <TableRow key={index}>
                                    <TableCell >{index+1}</TableCell>
                                    <TableCell  onClick={() =>
                                      window.open(
                                        `/#/InvDetailPage?inv=${inv?.invoice_Id}&vendorCode=${inv.vendor_Code}`
                                      )
                                    }
                                    key={index}>{inv.invoice_No}</TableCell>
                                    <TableCell >{moment(inv.invoice_Date).format("YYYY-MM-DD")}</TableCell>
                                    <TableCell >{Number(inv.invoice_Amount).toLocaleString()}</TableCell>
                                    <TableCell >{inv?.invoice_Desc!==null?inv?.invoice_Desc:"Document Number is not available in I2P Portal"}</TableCell>
                                    <TableCell>{inv.barcode}</TableCell>
                                  </TableRow>
                                ))}
                              </Table>
                              </TableCell>
                              </TableRow>
                            )}
                          </>
                        ))}
                                  </Table>
                                  </TableCell>
                        </TableRow>
                      </>
                    )}
                  </>
                ))}
              </TableBody>
              {loading && <TableSkeleton noOfColumns={4} noOfLines={3} />}
            </Table>
            {data?.length === 0 && !loading && <EmptyData />}
          </TableContainer>
        </Grid>
      </Grid>
    </div>
  );
}

export default Signatories_Table;
